import styled from 'styled-components';
import { COLORS, BORDER_RADIUS, SPACING } from '../../constants/theme';

export { CardSection, SectionDivider, SectionHeader, IconBadge } from '../../components/styles/FormCard.styles';

export const CompanyHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 16px;
`;

export const CompanyDivider = styled.div`
	width: 1px;
	height: 32px;
	background: ${COLORS.light.medium};
	flex-shrink: 0;
`;

export const CompanyPhoto = styled.img`
	width: 46px;
	height: 46px;
	border-radius: ${BORDER_RADIUS.medium};
	object-fit: cover;
	flex-shrink: 0;
`;

export const DoctorAvatar = styled.div`
	width: 52px;
	height: 52px;
	border-radius: 50%;
	background: ${COLORS.light.high};
	color: ${COLORS.white};
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	font-size: 17px;
	font-weight: 600;
`;

export const DoctorAvatarImage = styled.img`
	width: 100%;
	height: 100%;
	border-radius: 50%;
	object-fit: cover;
`;

export const StarRow = styled.div`
	display: flex;
	align-items: center;
	gap: ${SPACING.small};
`;

export const StarButton = styled.button`
	background: none;
	border: 0;
	padding: 0;
	cursor: pointer;
	line-height: 1;
`;

export const ReasonGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const ChipRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: ${SPACING.small};
`;

export const Chip = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 30px;
	padding: 0 12px !important;
	border-radius: 999px;
	font-size: 12px !important;
	cursor: pointer;
	transition: 150ms;
	border: 1px solid ${({ selected }) => (selected ? 'var(--theme-color)' : COLORS.light.medium)};
	background: ${({ selected }) => (selected ? COLORS.primary.low : COLORS.white)} !important;
	color: ${({ selected }) => (selected ? 'var(--theme-color)' : COLORS.dark.medium)};
	font-weight: ${({ selected }) => (selected ? 500 : 400)};
`;

export const CommentTextarea = styled.textarea`
	width: 100%;
	box-sizing: border-box;
	min-height: 88px;
	max-height: 200px;
	resize: vertical;
	padding: 10px !important;
	border: 1px solid ${COLORS.light.medium};
	border-radius: ${BORDER_RADIUS.small};
	font-family: inherit;
	font-size: 14px;
	line-height: 20px;
	color: ${COLORS.dark.pure};

	&:focus {
		outline: none;
		border-color: ${COLORS.primary.pure};
	}

	&::placeholder {
		color: ${COLORS.dark.low};
	}
`;

export const ObservationFieldWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const ObservationCounter = styled.span`
	align-self: flex-end;
	font-size: 12px;
	color: ${({ exceeded }) => (exceeded ? COLORS.danger.medium : COLORS.dark.low)};
`;

export const SubmittedState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: ${SPACING.medium};
	min-height: calc(100vh - 72px);
	text-align: center;
`;

export const SubmittedIcon = styled.div`
	width: 64px;
	height: 64px;
	border-radius: 50%;
	background: ${COLORS.success.low};
	color: ${COLORS.success.medium};
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 28px;
`;

export const SubmittedText = styled.div`
	max-width: 280px;
`;
